import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { PartnerService } from '../../core/services/partner.service';

//Mesma rota do menor e franqueado

@Component({
  selector: 'app-register',
  standalone: true,
  providers: [provideNgxMask()],
  imports: [
    CommonModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    NgxMaskDirective,
    MatIconModule,
    NavbarComponent,
    NavbarComponent,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent implements OnInit {
  private readonly urlGoogle =
    'https://play.google.com/store/apps/details?id=br.com.alphacode.madero&hl=pt_BR&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
  private readonly urlApple =
    'https://apps.apple.com/br/app/grupo-madero-app/id1579688707?l=en';
  private readonly urPrivacy =
    'https://madero.blob.core.windows.net/fidelidade/Documentos/Politica_de_Privacidade_Madero_Cashback.pdf';
  private readonly urTerms =
    'https://madero.blob.core.windows.net/fidelidade/Documentos/Regulamento_Madero_Cashback.pdf';

  form!: FormGroup;
  loading: boolean = false;
  imagePartner = '';

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private partnerService: PartnerService
  ) {}

  ngOnInit(): void {
    this.onBuildForm();
  }

  onBuildForm(): void {
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      mail: [null, [Validators.required, Validators.email]],
      cpf: [null, Validators.required],
      phone: [null, Validators.required],
      terms: [false, Validators.requiredTrue],
    });
  }

  onSubmit(): void {
    this.loading = true;
    const formResult = this.form.getRawValue();

    const body = {
      cpf: formResult.cpf,
      name: formResult.name,
      phone: formResult.phone,
      email: formResult.mail,
      password: '',
    };

    this.partnerService.registerConsumer(body).subscribe({
      next: (user) => {
        this.snackBar.open('Cadastro realizado com sucesso!', 'fechar');
        this.form.reset(
          {
            name: null,
            mail: null,
            cpf: null,
            phone: null,
            terms: false,
          },
          { emitEvent: false }
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      error: (err) => {
        this.loading = false;
        this.snackBar.open(
          'Houve um problema ao tentar enviar o cadastro!',
          'fechar'
        );
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  scrollToBotton(): void {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }

  onRedirect(nameLink: string): void {
    switch (nameLink) {
      case 'google':
        window.open(this.urlGoogle, '_blank');
        break;
      case 'apple':
        window.open(this.urlApple, '_blank');
        break;
      case 'terms':
        window.open(this.urTerms, '_blank');
        break;
      case 'privacy':
        window.open(this.urPrivacy, '_blank');
        break;

      default:
        break;
    }
  }
}
